$(document).ready(function () {
  var thirdPartyLinks = $('div#page-content a');

  // Loop through each link
  thirdPartyLinks.each(function () {
      var link = $(this);

      // Skip links that contain an <img> element
      if (link.find('img').length > 0) {
          var img = link.find('img');

          // Check if the link is third-party
          if (isThirdParty(link.attr('href'))) {
              var altText = img.attr('alt') || ''; // Get alt text, default to an empty string if not present

              // Add a custom message to the alt text
              if (altText) {
                  altText += ', This link will open in a new tab';
              } else {
                  altText = 'This link will open in a new tab';
              }

              img.attr('alt', altText); // Update the image's alt attribute
          }
          return; // Skip further processing for this link
      }

      // Check if the link leads to a third-party website
      if (isThirdParty(link.attr('href'))) {
          // Add the target="_blank" attribute
          link.attr('target', '_blank');

          // Add an aria-label indicating it will open in a new tab
          var existingText = link.text().trim();
          var newText = existingText + ', This link will open in a new tab';
          link.attr('aria-label', newText);
      }
  });

  // Function to check if a link is from a third-party website
  function isThirdParty(url) {
      // Skip empty or invalid URLs
      if (!url || typeof url !== 'string') return false;

      // Skip internal links that start with "/" or "#"
      if (url.startsWith('/') || url.startsWith('#')) return false;

      // Skip links that include the current domain
      if (url.includes('gonimble.com')) return false;

      // All other cases are considered third-party
      return true;
  }
});

$(document).ready(function(){
    $('br').attr('aria-hidden','true');
    $('img[src="//www.gonimble.com/cdn/shopifycloud/shopify/assets/payment_icons/american_express-12858714bc10cdf384b62b8f41d20f56d8c32c1b8fed98b662f2bfc158dcbcf0.svg"]').attr("alt","american express");
    $('img[src="//www.gonimble.com/cdn/shopifycloud/shopify/assets/payment_icons/apple_pay-f6db0077dc7c325b436ecbdcf254239100b35b70b1663bc7523d7c424901fa09.svg"]').attr("alt","Apple Pay");
    $('img[src="//www.gonimble.com/cdn/shopifycloud/shopify/assets/payment_icons/discover-cc9808e50193c7496e7a5245eb86d5e06f02e2476c0fe70f2c40016707d35461.svg"]').attr('alt','Discover');
    $('img[src="//www.gonimble.com/cdn/shopifycloud/shopify/assets/payment_icons/metapay-68da02f01a5d726d4b20e8248946d820b4573bf2f8bb06e6afc6d3eb04fac04d.svg"]').attr('alt','Meta pay');
    $('img[src="//www.gonimble.com/cdn/shopifycloud/shopify/assets/payment_icons/google_pay-c66a29c63facf2053bf69352982c958e9675cabea4f2f7ccec08d169d1856b31.svg"]').attr('alt','Google Pay');
    $('img[src="//www.gonimble.com/cdn/shopifycloud/shopify/assets/payment_icons/master-173035bc8124581983d4efa50cf8626e8553c2b311353fbf67485f9c1a2b88d1.svg"]').attr('alt','Master');
    $('img[src="//www.gonimble.com/cdn/shopifycloud/shopify/assets/payment_icons/paypal-49e4c1e03244b6d2de0d270ca0d22dd15da6e92cc7266e93eb43762df5aa355d.svg"]').attr('alt','Paypal');
    $('img[src="//www.gonimble.com/cdn/shopifycloud/shopify/assets/payment_icons/shopify_pay-957a48d1202dc65a7890b292de764ee886f7e64cea486ae82e291e9dc824c914.svg"]').attr('alt','shopify pay');
    $('img[src="//www.gonimble.com/cdn/shopifycloud/shopify/assets/payment_icons/venmo-e46496b4036966108664ea6a65bfeddd373275087df5f94cc3e5564fdb493eb0.svg"]').attr('alt','venmo');
    $('img[src="//www.gonimble.com/cdn/shopifycloud/shopify/assets/payment_icons/visa-319d545c6fd255c9aad5eeaad21fd6f7f7b4fdbdb1a35ce83b89cca12a187f00.svg"]').attr('alt','visa');
    $('a[href="https://nimbleforgood.zendesk.com/"]').attr('aria-label','FAQs & Instructions, this link will open in a new tab').attr('target','blank');
    $('img[src="https://cdn.shopify.com/s/files/1/2544/1940/files/Qi2_R0_100x100_59c3ca96-9e82-49d1-9eb6-61b92c3f24d3.jpg?v=1731454229"]').attr('alt','Wireless Power Consortium');
    $('table').attr('role','presentation');
    setTimeout(function() {
      $('.slider-arrow-left').attr('role', 'button').attr('aria-label', 'Previous');
      $('.slider-arrow-right').attr('role', 'button').attr('aria-label', 'Next');
  }, 2000);  
    $('iframe[src="https://verifypass.com/seller/embed/480d2376d?show_all=true"]').attr('title', 'Exclusive Discounts');
    $('div#numberCountElement span').each(function() {
      $(this).replaceWith('<strong>' + $(this).html() + '</strong>');
  });
    setTimeout(function () {
      $('img.zoomImg').attr('aria-hidden','true');
      $('img.zoomImg').attr('alt','');
    }, 3000);  
});

  $(document).ready(function() {
    $('.h1frst, .h1scnd, h4, .collection-kit__row_h2, a.add.button.clearfix, h3, .rmv-a a').each(function() {
      if ($(this).text().trim() === '') {
        $(this).remove();
      }
    });
  });
 
  window.onscroll = function() {
    scrollFunction();
  };
  
  function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("back-to-top").style.display = "block";
    } else {
      document.getElementById("back-to-top").style.display = "none";
    }
  }
  
  // When the user clicks on the button, scroll to the top of the document
  document.getElementById("back-to-top").onclick = function() {
    scrollToTop();
  };
  
  function scrollToTop() {
    const scrollStep = -window.scrollY / (500 / 15);
    const scrollInterval = setInterval(function() {
      if (window.scrollY !== 0) {
        window.scrollBy(0, scrollStep);
      } else {
        clearInterval(scrollInterval);
      }
    }, 15);
  }  